



























































































































































import Vue, { PropType } from 'vue'
import XButton from '@/components/atoms/Button/XButton.vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import { StoreShippingAddress } from '@/types/generated/graphql'

export default Vue.extend({
  name: 'PartnerShippingAddressItem',
  components: { XButton, XCard },
  props: {
    storeShippingAddress: {
      type: Object as PropType<StoreShippingAddress>,
      required: true,
    },
    partnerId: {
      type: String,
      required: true,
    },
  },
  methods: {
    onHandleEdit(partnerId: string, id: string) {
      this.$router.push({
        name: 'PartnerShippingAddressEdit',
        params: { partnerId: partnerId, id: id },
      })
    },
  },
})
